import { CompartmentCard, Card } from "@/src/components/cards";
import { openDrawer, openConfirmDialog } from "@/src/components/dialogs";
import { InfiniteFetchableList } from "@/src/components/fetchableLists";
import StaggeredAnimation from "@/src/components/staggeredAnimationComponent";
import {
  ReferenceCategory,
  Reference,
  referenceCategories,
} from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import { getUserId, uid, fromNow, getItemId } from "@/src/utils/utils";
import { useState } from "react";
import { ReferenceForm } from "./referenceForm";
import SnomedConceptCard from "../../snomed/snomedConceptCard";
import { Input } from "@/src/components/universalInput";
import { openAiReferenceForm } from "./aiReferenceForm";

export default function AdminReferencesCompartment({
  title,
  gridColumns,
  category,
  allowedCategoriesIds,
}: {
  title?: string;
  gridColumns?: number;
  category: { id: ReferenceCategory; name: string } | null | undefined;
  allowedCategoriesIds?: ReferenceCategory[];
}) {
  const [reload, setReload] = useState(0);
  let [searchKey, setSearchKey] = useState("");
  const [selectedCategory, setSelectedCategory] = useState<
    { id: ReferenceCategory; name: string } | null | undefined
  >(category);

  async function openReferenceDialog(reference: Reference) {
    await openDrawer({
      id: "referenceDialog",
      title: `Ajouter ${selectedCategory?.name}`,
      additionalClasses: ["big"],
      content: (
        <ReferenceForm
          current={reference}
          categories={allowedCategoriesIds || []}
          onChange={(newValue) => {
            reference = newValue;
            console.log("reference did change", newValue);
          }}
        />
      ),
      onConfirm: async () => {
        let inserted = await apiFetch("references", "addOne", {
          reference,
        });
        setReload((prev) => prev + 1);
      },
    });
  }

  return (
    <CompartmentCard
      title={title || selectedCategory?.name || "Références"}
      searchKey={searchKey}
      onSearch={(newValue) => {
        setSearchKey(newValue || "");
      }}
      onClick={async () => {
        let reference: any = {
          category: selectedCategory?.id,
          name: `${searchKey || ""}`,
        };
        await openReferenceDialog(reference);
      }}
      secondaryButtonTitle={"Générer un formulaire par IA"}
      onSecondaryClick={async () => {
        await openAiReferenceForm({
          currentCategory: selectedCategory?.id || "motive",
          allowedCategoriesIds,
          currentPrompt: ``,
          onSave: async (reference) => {
            setReload((prev) => prev + 1);
            await openReferenceDialog(reference);
          },
        });
      }}
    >
      <div className="c1 gap10">
        <Input
          name={""}
          type="select"
          options={[
            { id: null, name: "Tous" },
            ...Object.values(referenceCategories).filter((category) =>
              allowedCategoriesIds?.includes(category.id)
            ),
          ]}
          value={selectedCategory?.id}
          onChange={(newValue) => {
            let referenceCategory =
              referenceCategories[newValue as ReferenceCategory];
            setSelectedCategory(referenceCategory);
          }}
        />
        <InfiniteFetchableList
          searchKey={searchKey}
          queryKey={[
            "AdminReferenceCompartment",
            searchKey,
            selectedCategory?.id,
            reload,
          ]}
          limit={gridColumns == 3 ? 27 : 20}
          getFunction={(limit, offset, searchKey) => {
            // if (offset != 0) return [];
            return apiFetch("references", "loadMany", {
              userId: getUserId(),
              categoriesIds: selectedCategory?.id
                ? [selectedCategory?.id]
                : null,
              searchKey,
              offset,
              limit,
              showAll: true,
            });
          }}
        >
          {(references) => {
            return (
              <div className={`grid c${gridColumns || 1} gap15`}>
                {references?.map((reference, index) => {
                  return (
                    <StaggeredAnimation key={reference.id} index={index}>
                      <Card
                        // key={uid()}
                        color={"simple"}
                        title={reference.name}
                        onClick={async () => {
                          console.log("reference", reference);
                          await apiFetch(
                            "references",
                            "checkChildrenReferences",
                            { referenceId: getItemId(reference) }
                          );
                          await openReferenceDialog(reference);
                        }}
                        trailing={
                          <div className="gray">{reference.usageCount}</div>
                        }
                        onDelete={async () => {
                          await openConfirmDialog({
                            title: "Supprimer une référence",
                            content: `Voulez-vous
                          vraiment supprimer la référence ${reference.name} ?`,
                            onConfirm: async () => {
                              await apiFetch("general", "deleteAny", {
                                id: reference.id,
                                table: "references",
                              });
                            },
                          });
                        }}
                      >
                        <div className="c1 gap5 ">
                          <div className="gray mtop5">{reference.category}</div>

                          {reference.snomedConcept && (
                            <SnomedConceptCard
                              concept={reference.snomedConcept}
                              searchKey={searchKey}
                            />
                          )}
                        </div>
                      </Card>
                    </StaggeredAnimation>
                  );
                })}
              </div>
            );
          }}
        </InfiniteFetchableList>
      </div>
    </CompartmentCard>
  );
}
